<template>
    <div>
        <!-- Modal trigger button -->
        <button @click="openModal();" class="btn btn-success btn-sm"
            :title="ticket.status != 2 ? 'Không thể hoàn thành ticket khi chưa nhập giải pháp' : ''"
            :disabled="ticket.status != 2"> Hoàn thành
        </button>

        <!-- Bootstrap Vue Modal -->
        <b-modal :id="'completeTicketModal' + ticket.id" title="Hoàn thành ticket" size="lg" @hide="resetForm">
            <div class="modal-body-custom">
                <p class="mb-3">Mỗi ticket hoàn thành cần nhập nội dung tóm tắt phương án xử lý. Thông tin này được sử
                    dụng để các bên liên quan theo dõi kết quả của ticket.</p>
                <p class="mb-4">Vui lòng kiểm tra lại giải pháp đã nhập và chỉnh sửa lại cho các bên liên quan cùng theo
                    dõi và hỗ trợ học viên.</p>

                <form @submit.prevent="handleSubmit">
                    <div class="form-group">
                        <label for="solutionSummary">Tóm tắt phương án xử lý <span class="text-danger">*</span></label>
                        <ckeditor style="position: relative;" :editor="editor" v-model="solutionSummary" ></ckeditor>
                    </div>
                </form>
            </div>

            <template #modal-footer="{ cancel }">
                <button type="button" class="btn btn-secondary" @click="cancel()">Hủy bỏ</button>
                <button type="button" class="btn btn-primary" @click="handleSubmit" :disabled="update_loading">
                    <span v-if="update_loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                    Xác nhận
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { CHANGE_STATUS } from "../../../../../core/services/store/user/ticket.module";
import CustomEditor from "@/core/plugins/ckeditor5/custom-editor";


export default {
    name: "ModalCompleteTicket",
    props: {
        ticket: {
            type: Object,
            default: () => {
                return null;
            }
        },
        solution_summary: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            update_loading: false,
            solutionSummary: '',
            editor: CustomEditor,
        }
    },

    methods: {
        innerText(text) {
            if (!text) return '';
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = text;
            return tempDiv.innerText || tempDiv.textContent || '';
        },

        openModal() {
            this.resetForm();
            this.$bvModal.show('completeTicketModal' + this.ticket.id);
        },

        closeModal() {
            this.$bvModal.hide('completeTicketModal' + this.ticket.id);
        },

        resetForm() {
            this.solutionSummary = this.cleanCkHtml(this.solution_summary);
        },

        async handleSubmit() {
            this.update_loading = true;

            try {
                const res = await this.$store.dispatch(CHANGE_STATUS, {
                    id: this.ticket.id,
                    status: 3, // Hoàn thành
                    status_feedback: this.ticket.status_comment === 1 ? 2 : '',
                    solution_summary: this.solutionSummary.trim()
                });

                if (!res.error) {
                    this.$bvToast.toast('Ticket đã được xử lý xong', {
                        title: 'Thành công',
                        variant: 'success',
                        solid: true
                    });
                    this.$emit('changeStatusSuccess', true);
                    this.closeModal();
                }
            } catch (error) {
                console.error('Error completing ticket:', error);
            } finally {
                this.update_loading = false;
            }
        },
        cleanCkHtml(html) {
        if(!html) return '';
        // remove fake selection
        html = html.replace(/<div class="ck-fake-selection-container"[\s\S]*?<\/div>/g, '');

        // remove ck internal blocks
        html = html.replace(/<div class="ck ck-reset_all ck-widget__type-around"[\s\S]*?<\/div>\s*<\/div>/g, '');
        html = html.replace(/<div class="ck ck-reset_all ck-widget__resizer"[\s\S]*?<\/div>/g, '');

        // remove ck-* classes on figure (giữ lại class image/image_resized nếu muốn)
        html = html.replace(/class="([^"]*)"/g, (m, cls) => {
          const keep = cls
              .split(/\s+/)
              .filter(c => !c.startsWith('ck-')) // bỏ ck-*
              .join(' ');
          return keep ? `class="${keep}"` : '';
        });

        return html;
      }
    }
}
</script>

<style scoped>
.modal-body-custom {
    padding: 1rem 0;
}

/* Custom size for lg modal to be more reasonable */
::v-deep .modal-lg {
    max-width: 800px;
}
</style>